    
export default {
    name: 'recommend',
    data() {
        return {
            loading: false,
            recommendSource: []
        }
    },
    created() {
        this.getRecommendList()
    },
    watch: {

    },

    methods: {
        async getRecommendList() {
            //推荐视频
            this.loading = true
            let res = await this.$global.recommend_list()
            res.code == 200 ? (this.recommendSource = res.data.video_list, this.loading = false) : []
        },
    }
}
